import API from '../../api';

const ROOT = '/v1/combat-pro/runtime';

export async function syncGeneratorContext(payload) {
  return (await API.put(ROOT + '/context-board', payload)).data;
}

export async function fetchGeneratorContext(campaignId, encounterId) {
  const params = new URLSearchParams({ campaign_id: campaignId });
  if (encounterId) params.set('encounter_id', encounterId);
  return (await API.get(ROOT + '/context-board?' + params.toString())).data;
}

export async function createAfterActionPacket(payload) {
  return (await API.post(ROOT + '/after-action', payload)).data;
}

export async function sendAfterActionHandoff(packetId, payload) {
  return (await API.post(ROOT + '/after-action/' + encodeURIComponent(packetId) + '/handoffs', payload)).data;
}
